import { FeatureFlag } from '../../factories'

const FFTags= new FeatureFlag(process.env.REACT_APP_TAGS_DISPLAY)
const isTagsDisplayed = FFTags.basicValidation()

export {
  isTagsDisplayed
}
